import { clientCaseFactFindLetterOfAuthorityInformationRequestPrintApi } from './print';

export function clientCaseFactFindLetterOfAuthorityInformationRequestApi(path: string) {
  return {
    path,
    print: () => clientCaseFactFindLetterOfAuthorityInformationRequestPrintApi(`${path}/print`),
  };
}
